import React, { AnchorHTMLAttributes, FC } from 'react';

import { LucidTheme } from '../../types/types';

export interface DividerProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** The children passed to the Divider component. */
  children: React.ReactNode;
  /** Allows the component to get additional styles. */
  className?: string;
}

const Divider: FC<DividerProps> = ({ children, className, ...rest }) => (
  <a
    {...rest}
    css={(theme: LucidTheme) => ({
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      width: '100%',
      '&::before': {
        content: '""',
        backgroundColor: theme.colors.coolGrey[10],
        width: '100%',
        height: '1px',
      },
    })}
    /* eslint-disable-next-line react/jsx-sort-props */
    className={className}
  >
    {children}
  </a>
);

export { Divider };
export default Divider;
